/** 去掉文件名后缀，如 "系统架构图.png" → "系统架构图" */
export const stripExt = (name: string): string => name.replace(/\.[^.]+$/, '');
